







import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { blockableBlockColorFragment, blockColorMixin } from '@/composables/block-color';

import { ImageGalleryBlockDataFragment } from '@/graphql/generated';
import { PageBlockMixin } from '@/modules/cms';
import { medium1x1ImageFragment } from '@/graphql/queries/image.fragments';

@Component({
  graphqlData: gql`
    fragment ImageGalleryBlockData on ImageGalleryBlock {
      id
      title
      images {
        ...Medium1x1ImageData
      }
      ...BlockColor
    }

    ${medium1x1ImageFragment}
    ${blockableBlockColorFragment}
  `,
})
export default class ImageGalleryBlock extends mixins(PageBlockMixin<ImageGalleryBlockDataFragment>(), blockColorMixin) {}
